import { JSX } from 'react'

import { GroupFooter } from '~/components/component-library/Group/components/GroupFooter'
import { type GroupProps } from '~/components/component-library/Group/types'
import { LabelValue } from '~/components/component-library/LabelValue'
import styles from '~/styles/components/Group.module.scss'
import { cn } from '~/utils/tailwind-utils'

export { GroupIconAction } from '~/components/component-library/Group/components/GroupIconAction'
export {
  type GroupProps,
  type GroupIconActionProps,
} from '~/components/component-library/Group/types'

export const Group = ({
  children,
  tooltip,
  secondaryDisplay,
  label,
  secondaryLabel,
  footer,
  description,
  layout = 'vertical',
}: GroupProps) => {
  if (layout === 'horizontal') {
    return (
      <div className="w-full">
        <LabelValue
          label={label ?? ''}
          secondaryLabel={secondaryLabel}
          description={description}
          value={(children as JSX.Element) ?? ''}
          tooltip={tooltip}
          size="small"
        />
        {footer && <GroupFooter footer={footer} />}
      </div>
    )
  }

  return (
    <div className="flex w-full flex-col gap-2">
      {label && (
        <LabelValue
          label={label}
          secondaryLabel={secondaryLabel}
          description={description}
          value={secondaryDisplay ?? ''}
          tooltip={tooltip}
          size="small"
        />
      )}
      <div className={cn('flex-grow', styles.wrap)}>{children}</div>
      {footer && <GroupFooter footer={footer} />}
    </div>
  )
}
